export const ProfileAutofill = () => ({
  autofillEnabled: true,
  open: true,
  profileData: {},

  init() {
    const profileDataEl = this.$el.querySelector('[data-profile]')
    if (profileDataEl) {
      try {
        this.profileData = JSON.parse(profileDataEl.dataset.profile)
      } catch (e) {
        console.error('Failed to parse profile data:', e)
        this.profileData = {}
      }
    }

    this.$nextTick(() => {
      if (this.autofillEnabled) {
        this.fillFormWithProfile()
      }
    })
  },

  handleAutofillToggle() {
    if (this.autofillEnabled) {
      this.fillFormWithProfile()
    } else {
      this.clearForm()
    }
  },

  fillFormWithProfile() {
    const form = this.$el.closest('form')
    if (!form) return

    const hasIncompleteData = !this.profileData.name || !this.profileData.phone

    if (hasIncompleteData) {
      this.showIncompleteDataNotice()
    }

    if (this.profileData.name) {
      const nameField = form.querySelector('[name*="[name]"]')
      if (nameField) nameField.value = this.profileData.name
    }

    if (this.profileData.email) {
      const emailField = form.querySelector('[name*="[email]"]')
      if (emailField) emailField.value = this.profileData.email
    }

    if (this.profileData.phone) {
      const phoneField = form.querySelector('[name*="[phone_number]"]')
      if (phoneField) phoneField.value = this.profileData.phone
    }

    if (this.profileData.country_code) {
      const countryCodeField = form.querySelector('[name*="[country_code]"]')
      if (countryCodeField) countryCodeField.value = this.profileData.country_code
    }
  },

  clearForm() {
    const form = this.$el.closest('form')
    if (!form) return

    const nameField = form.querySelector('[name*="[name]"]')
    const emailField = form.querySelector('[name*="[email]"]')
    const phoneField = form.querySelector('[name*="[phone_number]"]')
    const countryCodeField = form.querySelector('[name*="[country_code]"]')

    if (nameField) nameField.value = ''
    if (emailField && this.profileData.email !== emailField.value) emailField.value = ''
    if (phoneField) phoneField.value = ''
    if (countryCodeField) countryCodeField.value = '+886'
  },

  showIncompleteDataNotice() {
    const message = document.querySelector('meta[name="autofill-incomplete-notice"]')?.content || 
                   '會員中心尚有部分資料未填寫，請於下單後至會員中心補齊，以加速未來購物流程'
    
    const toast = document.createElement('div')
    toast.className = 'toast toast-top toast-center z-50'
    toast.innerHTML = `
      <div class="alert alert-info">
        <span>${message}</span>
      </div>
    `
    document.body.appendChild(toast)

    setTimeout(() => {
      toast.remove()
    }, 5000)
  }
})
